import React, { Component } from 'react'
import './Style.scss'
import LinkOnly from './LinkOnly';

export class TextOnly extends Component {
    

    render() {
        var content = this.props.articleObj;
        return (
           
                <div className={`${content.attributes.articleRendering} ${content.attributes.class}`} data-type="TextOnly" >
                    <div className='card-design'>
                        {content.title ?
                            <p className='card-text' dangerouslySetInnerHTML={{ __html: content.title }}></p>
                        :""}
                        {content.body ?
                            <div className='card-body cms-green-btn' dangerouslySetInnerHTML={{ __html: content.body }}></div>
                         :""}
                    </div>
                    {content.attributes.linkName ? <LinkOnly articleObj={content} /> : ""}
                </div>
           
        )
    }
}

export default TextOnly